// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PasswordInputField should render PasswordInputField component 1`] = `ShallowWrapper {}`;
